import { queryOptions } from '@tanstack/react-query';
import type { ListCardsQuery } from '@klopotun/contracts';
import { cardQueryRoot } from '../../../../shared/api/index.js';
import { getCards } from '../requests/get-cards.js';

const CARDS_ON_OFFER: ListCardsQuery = { includeArchived: false };

export const cardQueries = {
  ...cardQueryRoot,
  list: (query: ListCardsQuery = CARDS_ON_OFFER) =>
    queryOptions({
      queryKey: [...cardQueries.lists(), query] as const,
      queryFn: ({ signal }) => getCards(query, signal),
    }),
};
